"use strict";

var __importDefault = undefined && undefined.__importDefault || function (mod) {
    return mod && mod.__esModule ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __importDefault(require("vue"));
var DatepickerDate_vue_1 = __importDefault(require("../Workflow/Components/Input/DatepickerDate.vue"));
vue_1.default.component("date-picker", DatepickerDate_vue_1.default);


//////////////////
// WEBPACK FOOTER
// ./_wwwsrc/js/SharedComponent/datepicker.ts
// module id = 636
// module chunks = 0